/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

export default {
  sales: {
    labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: { label: "Applications", data: [50, 40, 300, 320, 500, 350, 200, 230, 500] },
  },
  tasks: {
    labels: ["Sept", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apil", "May", "Jun", "Jul", "Aug"],
    datasets: { label: "Admissions", data: [50, 40, 100, 120, 200, 250, 300, 230, 400, 450 ,300,500] },
  },
};
